<mat-form-field appearance="fill">
  <mat-label>Author</mat-label>
  <mat-select [formControl]="ctrl">
    <mat-option>All</mat-option>
    <mat-option *ngFor="let author of authors" [value]="author">{{ author.name}}</mat-option>
  </mat-select>
</mat-form-field>
